import { type ActionItem, toastStore } from 'shared/ui'
import { writeTextToClipboard } from 'shared/lib'
import { type ReviewRow } from 'entities/Review'
import { ReviewActionsStore } from 'pages/reviews/store'

export const reviewActionsStore = new ReviewActionsStore()

export const getReviewActions = ({
  item,
  onSuccessDelete,
}: {
  item: ReviewRow
  onSuccessDelete?: () => void
}): ActionItem[] => [
  {
    text: 'Copy link',
    icon: 'link',
    onAction: () => {
      writeTextToClipboard(item.short_url)
      toastStore.add({ type: 'info', title: 'Copied' })
    },
  },
  { text: 'Edit', icon: 'edit' },
  { text: 'Duplicate', icon: 'copy' },
  {
    text: 'Delete',
    icon: 'delete',
    onAction: () => reviewActionsStore.onDelete(item.id, onSuccessDelete),
  },
]
